export default class Bar {
  constructor(map, context) {
    this.map = map
  }
  add(point) {
    var map = this.map
    var lineGeometry = []
    for (var l = 0; l < 2; l++) {
      var delta = [0, 0, l * 200]
      var newCoordinate = point.map(function(d, i) {
        return d + delta[i]
      })
      lineGeometry.push(newCoordinate)
    }
    console.log("Tube's line geometry: ", lineGeometry)
    // map.on('style.load', function() {
    map.addLayer({
      id: 'custom_layer',
      type: 'custom',
      renderingMode: '3d',
      onAdd: function(map, mbxContext) {
        window.tb = new Threebox(map, mbxContext, { defaultLights: true })
        var geometry = new THREE.BoxGeometry(1, 1, 50 / point[3])
        var material = new THREE.MeshPhysicalMaterial({ color: 0x00ff00 })
        window.cube = new THREE.Mesh(geometry, material)
        window.obj = tb.Object3D({ obj: cube }).setCoords(point)
        tb.add(obj)
        // Threebox.prototype.defaultLights = function() {
        //   // this.scene.add(new THREE.AmbientLight(0xffffff))
        //   var sunlight = new THREE.DirectionalLight(0xffffff, 0.5)
        //   sunlight.position.set(-200, 1000, 10000)
        //   sunlight.matrixWorldNeedsUpdate = true
        //   this.world.add(sunlight)
        // }
        // window.tb = new Threebox(map, mbxContext, { defaultLights: true })
        // var tubeOptions = {
        //   geometry: lineGeometry,
        //   radius: 30,
        //   sides: 4,
        //   material: 'MeshBasicMaterial',
        //   color: '#00ffff',
        //   width: 6
        // }
        // let tube = tb.tube(tubeOptions)
        // // let line = tb.line(tubeOptions)
        // // tube.material.wireframe = true
        // tb.add(tube)
        // var material = new THREE.LineBasicMaterial({ color: 0x0000ff })
        // var geometry = new THREE.Geometry()
        // geometry.vertices.push(new THREE.Vector3(-10, 0, 0))
        // geometry.vertices.push(new THREE.Vector3(0, 10, 0))
        // geometry.vertices.push(new THREE.Vector3(10, 0, 0))
        // var line = new THREE.Line(geometry, material)
        // tb.add(line)
        // tb.add(line)
      },

      render: function(gl, matrix) {
        tb.update()
      }
    })
    // })
  }
}



// WEBPACK FOOTER //
// ./src/framework/map/three/threebox.js